import * as Preact from "preact"

import elements from "@frog/source/data/elements.js"
import Zone from "@frog/source/models/Zone.js"

const KEYWORDS = {
    "bloodlust": {
        "name": "Bloodlust",
        "description": () => {
            return "+1 for each damaged unit."
        }
    },
    "engage": {
        "name": "Engage",
        "description": () => {
            return "Doubled if target is at full health."
        }
    },
    "mana": {
        "name": "Mana",
        "description": () => {
            return "+1 for each point of mana you've accrued."
        }
    },
    "unused rolls": {
        "name": "Unused Rolls",
        "description": () => {
            return "+1 for your remaining unused rolls."
        }
    },
    "hurt": {
        "name": "Hurt",
        "description": () => {
            return "You also take damage."
        }
    },
    "rampage": {
        "name": "Rampage",
        "description": () => {
            return "If you kill a unit, you can move and attack again."
        }
    },
    "wound": {
        "name": "Wound",
        "description": () => {
            return "When wounded, you take additional damage with each attack. +1 damage for each wound."
        },
    },
    "poison": {
        "name": "Poison",
        "description": () => {
            return "When poisoned, you take damage at the end of their turn. +1 damage for each poison."
        },
    },
}

function Power({children}) {
    if(children == "" || children == 0) {
        return
    } else {
        return (parseInt(children) / 10) || children
    }
}

function Keyword() {
    const keywordKey = this.props.children.toLowerCase()
    const keyword = KEYWORDS[keywordKey]
    return (
        <span class="Keyword" link={keyword != undefined}>
            {this.props.children}
        </span>
    )
}

// expecting the children to be the elementKey!!
function Element({children}) {
    if(children == "" || children == 0) {
        return
    } else {
        return <span class="Keyword" link={true} element={children}>{elements[children].name}</span>
    }
}


const BASIC_DESCRIPTION = ({stage, unit, item}) => {
    if(stage.currentEncounterKey == 1) {
        return <span>Attack for <Power>{item.power}</Power> <Element>{item.element}</Element> Damage</span>
    } else {
        <span>Attack for <Power>{item.power}</Power></span>
    }
}

export default {
    "slime-pentapod": {
        "title": "Pentapod",
        "description": ({stage, unit, item}) => <span>Attack for {item.power / 10} <span class="Keyword" link={true} element={item.element}>{elements[item.element].name}</span> Damage</span>,
        "icon": require("@frog/source/assets/images/dice-tactics/actions/tentacle-strike.png"),
        "element": "water",
        "skillKeys": ["attack"],
        "power": 20,
        "attackrange": 1
    },
    "skeleton-sword": {
        "title": "Machete",
        "description": ({stage, unit, item}) => <span>Attack for <Power>{item.power}</Power>.</span>,
        "icon": require("@frog/source/assets/images/dice-tactics/actions/machete.png"),
        "element": "fire",
        "skillKeys": ["attack"],
        "power": 10,
        "attackrange": 1
    },
    "goblin-bow": {
        "title": "Shortbow",
        "description": ({stage, unit, item}) => <span>Attack for <Power>{item.power}</Power> from 2 tiles away.</span>,
        "icon": require("@frog/source/assets/images/dice-tactics/actions/high-shot.png"),
        "element": "water",
        "skillKeys": ["attack"],
        "power": 10,
        "attackrange": 2
    },
    "burning-blade": {
        // "unitKey": "dog",
        "title": "Burning Blade",
        "description": BASIC_DESCRIPTION,
        "flavor": "Forged of a fallen star from the westward sky, the burning blade can never be extinguished, no matter how dark the night.",
        "icon": require("@frog/source/assets/images/dice-tactics/actions/shard-sword.png"),
        "element": "fire", "skillKeys": ["attack"], "attackrange": 1, "power": 20
    },
    "earthen-hammer": {
        // "unitKey": "dog",
        "title": "Earthen Hammer",
        "keyword": KEYWORDS["push"],
        "description": ({stage, unit, item}) => <span>Attack for {item.power / 10}, and <Keyword>Push</Keyword> for {item.power / 10}</span>,
        "icon": require("@frog/source/assets/images/dice-tactics/actions/thor-hammer.png"),
        "element": "earth", "skillKeys": ["attack"], "properties": ["forceful"], "attackrange": 1, "power": 10
    },
    "icicle-lance": {
        // "unitKey": "mouse",
        "title": "Icicle Lance",
        "description": BASIC_DESCRIPTION,
        "icon": require("@frog/source/assets/images/dice-tactics/actions/spear-hook.png"),
        "element": "water", "skillKeys": ["attack"], "power": 10, "attackrange": 1,
    },
    "flaming-crossbow": {
        // "unitKey": "mouse",
        "title": "Flaming Crossbow",
        "description": ({stage, unit, item}) => <span>Attack for {item.power / 10}, from 2 tiles away</span>,
        "icon": require("@frog/source/assets/images/dice-tactics/actions/crossbow.png"),
        "element": "fire", "skillKeys": ["attack"], "power": 10, "attackrange": 2
    },
    "bubble-wand": {
        // "unitKey": "frog",
        "title": "Bubble Wand",
        "description": ({stage, unit, item}) => <span>Attack for {item.power / 10}, from 2 tiles away</span>,
        "icon": require("@frog/source/assets/images/dice-tactics/actions/orb-wand.png"),
        "element": "water", "skillKeys": ["attack"], "power": 20, "attackrange": 2, "attackarea": 2
    },
    "banjo": {
        // "unitKey": "frog",
        "title": "Banjo",
        "description": ({stage, unit, item}) => <span>Stun an enemy or refresh an ally</span>,
        "icon": require("@frog/source/assets/images/dice-tactics/actions/banjo.png"),
        "element": "earth", "skillKeys": ["rally", "stun"], "power": 0, "attackrange": 1
    },
    "bleeding-blade": {
        "unitKey": "dog",
        "title": "Bloodied Blade",
        "keyword": KEYWORDS["bloodlust"],
        "description": ({stage, unit, item}) => <span>Attack for <Power>{item.power}</Power> + <Power>{item.powerboost({stage, unit})}</Power> <Keyword>Bloodlust</Keyword>.</span>,
        "icon": require("@frog/source/assets/images/dice-tactics/actions/lightning-saber.png"),
        "element": "fire", "skillKeys": ["attack"], "power": 10, "attackrange": 1,
        "powerboost": ({stage, unit, item}) => {
            const currentEncounter = stage.encounters[stage.currentEncounterKey]
            const damagedUnits = Object.values(stage.units).filter((unit) => {
                return unit.isDead != true
                    && unit.health < unit.maxhealth
                    && Zone.isInBounds(currentEncounter, unit.position)
            })
            return damagedUnits.length * 10
        },
    },
    "bone-knife": {
        "unitKey": "dog",
        "title": "Bone Knife",
        "keyword": KEYWORDS["hurt"],
        "description": ({stage, unit, item}) => <span>Attack for <Power>{item.power}</Power>, and <Keyword>Hurt</Keyword> for <Power>{item.power}</Power>.</span>,
        "icon": require("@frog/source/assets/images/dice-tactics/actions/bone-knife.png"),
        "element": "fire", "skillKeys": ["attack"], "properties": ["pain"], "attackrange": 1, "power": 20
    },
    "bone-club": {
        "unitKey": "dog",
        "title": "Bone Club",
        "keyword": KEYWORDS["hurt"],
        "description": ({stage, unit, item}) => <span>Attack for <Power>{item.power}</Power>, and <Keyword>Hurt</Keyword> for <Power>{item.power}</Power>.</span>,
        "icon": require("@frog/source/assets/images/dice-tactics/actions/bone-mace.png"),
        "element": "earth", "skillKeys": ["attack"], "properties": ["pain"], "attackrange": 1, "power": 20
    },
    "katana": {
        "unitKey": "dog",
        "title": "Katana",
        "keyword": KEYWORDS["engage"],
        "description": ({stage, unit, item}) => <span>Attack for <Power>{item.power}</Power> x <Keyword>Engage</Keyword>.</span>,
        "icon": require("@frog/source/assets/images/dice-tactics/actions/katana.png"),
        "element": "fire", "skillKeys": ["attack"], "power": 20, "attackrange": 1,
        "properties": ["counter"],
    },
    "zweihander": {
        "unitKey": "dog",
        "title": "Zweihander",
        // "keyword": KEYWORDS["unused rolls"],
        "description": ({stage, unit, item}) => <span>Attack for <Power>{item.power}</Power> + <Power>{item.powerboost({stage, unit})}</Power> <Keyword>Unused Rolls</Keyword>.</span>,
        "icon": require("@frog/source/assets/images/dice-tactics/actions/relic-blade.png"),
        "element": "fire", "skillKeys": ["attack"], "power": 20, "attackrange": 1,
        "powerboost": ({stage, unit, item}) => {
            return (stage.player.rollcount || 0) * 10
        },
    },
    "buckler": {
        "unitKey": "dog",
        "title": "Buckler",
        "keyword": KEYWORDS["defend"],
        "description": ({stage, unit, item}) => <span>Attack for <Power>{item.power}</Power> or Defend for <Power>{item.power}</Power>.</span>,
        "icon": require("@frog/source/assets/images/dice-tactics/actions/round-shield.png"),
        "element": "earth", "skillKeys": ["attack", "defend"], "attackrange": 1, "power": 20
    },
    "forge-hammer": {
        "unitKey": "dog",
        "title": "Forge Hammer",
        "keyword": KEYWORDS["strengthen"],
        "description": ({stage, unit, item}) => <span>Attack for <Power>{item.power}</Power> or <Keyword>Strengthen</Keyword> for <Power>{item.power}</Power>.</span>,
        "icon": require("@frog/source/assets/images/dice-tactics/actions/anvil-impact.png"),
        "element": "earth", "skillKeys": ["attack", "strengthen"], "attackrange": 1, "power": 10
    },
    "tomahawk": {
        "unitKey": "dog",
        "title": "Tomahawk",
        "description": ({stage, unit, item}) => <span>Attack for <Power>{item.power}</Power>, from 1 or 2 tiles away.</span>,
        "icon": require("@frog/source/assets/images/dice-tactics/actions/tomahawk.png"),
        "element": "earth", "skillKeys": ["attack"], "power": 10,
        "attackrange": {"min": 1, "max": 2, "orthogonal": true, "diagonal": true},
    },
    "warhammer": {
        "unitKey": "dog",
        "title": "Warhammer",
        "keyword": KEYWORDS["push"],
        "description": ({stage, unit, item}) => <span>Attack for <Power>{item.power}</Power>, and <Keyword>Push</Keyword> for <Power>{item.power}</Power>.</span>,
        "icon": require("@frog/source/assets/images/dice-tactics/actions/thor-hammer.png"),
        "element": "earth", "skillKeys": ["attack", "push"], "properties": ["forceful"], "attackrange": 1, "power": 10
    },
    "glaive": {
        "unitKey": "dog",
        "title": "Glaive",
        "description": ({stage, unit, item}) => <span>Attack for <Power>{item.power}</Power>, both orthogonally and diagonally.</span>,
        "icon": require("@frog/source/assets/images/dice-tactics/actions/glaive.png"),
        "element": "water", "skillKeys": ["attack"], "power": 20,
        "attackrange": {"min": 1, "max": 1, "orthogonal": true, "diagonal2": true},
    },


    "rapier": {
        "unitKey": "mouse",
        "title": "Rapier",
        "keyword": KEYWORDS["engage"],
        "description": ({stage, unit, item}) => <span>Attack for <Power>{item.power}</Power> x <Keyword>Engage</Keyword>.</span>,
        "icon": require("@frog/source/assets/images/dice-tactics/actions/sword-hilt.png"),
        "element": "fire", "skillKeys": ["attack"], "power": 20, "attackrange": 1,
        "properties": ["engage"],
    },
    "poison-dagger": {
        "unitKey": "mouse",
        "title": "Venomfang",
        "keyword": KEYWORDS["poison"],
        "description": ({stage, unit, item}) => <span>Attack for <Power>{item.power}</Power>. <Keyword>Poison</Keyword> for <Power>{item.power}</Power>.</span>,
        "icon": require("@frog/source/assets/images/dice-tactics/actions/dripping-blade.png"),
        "element": "fire", "skillKeys": ["attack"], "attackrange": 1, "power": 10,
        "properties": ["poisonous"],
    },
    "rose-dagger": {
        "unitKey": "mouse",
        "title": "Rose Dagger",
        "keyword": KEYWORDS["wound"],
        "description": ({stage, unit, item}) => <span>Attack for <Power>{item.power}</Power>. <Keyword>Wound</Keyword> for <Power>{item.power}</Power>.</span>,
        "icon": require("@frog/source/assets/images/dice-tactics/actions/dagger-rose.png"),
        "element": "fire", "skillKeys": ["attack"], "attackrange": 1, "power": 10,
        "properties": ["wounding"],
    },
    "assassin-blades": {
        "unitKey": "mouse",
        "title": "Assassin Blades",
        "keyword": KEYWORDS["rampage"],
        "description": ({stage, unit, item}) => <span>Attack for <Power>{item.power}</Power>. <Keyword>Rampage</Keyword>.</span>,
        "icon": require("@frog/source/assets/images/dice-tactics/actions/assassin-pocket.png"),
        "element": "fire", "skillKeys": ["attack"], "properties": ["rampage"], "attackrange": 1, "power": 20
    },
    "dodge": {
        "unitKey": "mouse",
        "title": "Dodge",
        "description": "Take no damage from any attacks",
        "icon": require("@frog/source/assets/images/dice-tactics/actions/divert.png"),
        "skillKeys": ["inflict-damage"], "properties": ["dodging"]
    },
    "shortbow": {
        "unitKey": "mouse",
        "title": "Shortbow",
        "description": ({stage, unit, item}) => <span>Attack for <Power>{item.power}</Power> from 2 tiles away.</span>,
        "icon": require("@frog/source/assets/images/dice-tactics/actions/high-shot.png"),
        "element": "water", "skillKeys": ["attack"], "power": 20, "attackrange": 2,
    },
    "musket": {
        "unitKey": "mouse",
        "title": "Musket",
        "description": ({stage, unit, item}) => <span>Attack for <Power>{item.power}</Power> from up to 5 tiles away, orthogonally.</span>,
        "icon": require("@frog/source/assets/images/dice-tactics/actions/musket.png"),
        "element": "earth", "skillKeys": ["attack"], "power": 20,
        "attackrange": {"min": 1, "max": 5, "orthogonal": true},
    },
    "swap": {
        "unitKey": "mouse",
        "title": "Swap",
        "description": ({stage, unit, item}) => <span>Swap spaces with another unit.</span>,
        "icon": require("@frog/source/assets/images/dice-tactics/actions/cycle.png"),
        "skillKeys": ["swap"],
    },


    "trumpet": {
        "unitKey": "frog",
        "title": "Trumpet",
        "description": ({stage, unit, item}) => <span><Keyword>Strengthen</Keyword> an ally for <Power>{item.power}</Power>,<br/>or <Keyword>Weaken</Keyword> an enemy for <Power>{item.power}</Power>.</span>,
        "icon": require("@frog/source/assets/images/dice-tactics/actions/trumpet.png"),
        "element": "fire", "skillKeys": ["strengthen", "weaken"], "power": 10, "attackrange": 1
    },
    "shillelagh": {
        "unitKey": "frog",
        "title": "Shillelagh",
        "keyword": KEYWORDS["mana"],
        "description": ({stage, unit, item}) => <span>Attack for <Power>{item.power}</Power> + <Power>{item.powerboost({stage, unit})}</Power> <Keyword>Mana</Keyword>.</span>,
        "icon": require("@frog/source/assets/images/dice-tactics/actions/wizard-staff.png"),
        "element": "earth", "skillKeys": ["attack"], "power": 10, "attackrange": 1,
        "powerboost": ({stage, unit, item}) => {
            return (stage.player.mana || 0) * 10
        },
    },
}
